import { render, staticRenderFns } from "./allProducts.vue?vue&type=template&id=bf6b3136&"
import script from "./allProducts.vue?vue&type=script&lang=js&"
export * from "./allProducts.vue?vue&type=script&lang=js&"
import style0 from "./allProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports